export const listSanitizer = params => {
  const { contractTypeId } = params;
  const sanitizedParams = {
    perPage: params.perPage,
    page: params.page,
    geographicLocationId: params.geographicLocationId,
    stratum: params.stratum,
    quota: params.quota
  };

  if (contractTypeId === 'comercial') {
    sanitizedParams.contractTypeId = 2;
  }

  if (contractTypeId === 'residencial') {
    sanitizedParams.contractTypeId = 1;
  }

  return sanitizedParams;
};

export const updateSanitizer = params => {
  const sanitizedParams = {
    stratumQuota: Number(params.stratumQuota.replaceAll('.', '')),
    rolloverQuota: Number(params.rolloverQuota.replaceAll('.', '')),
    allowedTimeSinceGasInstallation: params.allowedTimeSinceGasInstallation.toString(),
    allowedTimeSinceLastDateBrillaProductWasInArrears: params.allowedTimeSinceLastDateBrillaProductWasInArrears.toString(),
    allowedTimeSinceLastDateGasProductWasInArrears: params.allowedTimeSinceLastDateGasProductWasInArrears.toString(),
    allowedTimeSinceLastDateOtherServicesWereInArrears: params.allowedTimeSinceLastDateOtherServicesWereInArrears.toString(),
    allowedTimeSinceLastPunishment: params.allowedTimeSinceLastPunishment.toString(),
    maximumNetworkBalance: params.maximumNetworkBalance.toString().replaceAll('.', ''),
    numberOfSuspensionsPeriodToEvaluate: params.numberOfSuspensionsPeriodToEvaluate.toString(),
    requiredOwnershipPeriod: params.requiredOwnershipPeriod.toString()
  };
  return sanitizedParams;
};

export const createSanitizer = params => {
  const sanitizedParams = {
    stratum: Number(params.stratum),
    geographicLocationId: params.geographicLocationId ? Number(params.geographicLocationId) : null,
    stratumQuota: Number(params.stratumQuota.replaceAll('.', '')),
    rolloverQuota: Number(params.rolloverQuota.replaceAll('.', '')),
    allowedTimeSinceGasInstallation: params.allowedTimeSinceGasInstallation.toString(),
    allowedTimeSinceLastDateBrillaProductWasInArrears: params.allowedTimeSinceLastDateBrillaProductWasInArrears.toString(),
    allowedTimeSinceLastDateGasProductWasInArrears: params.allowedTimeSinceLastDateGasProductWasInArrears.toString(),
    allowedTimeSinceLastDateOtherServicesWereInArrears: params.allowedTimeSinceLastDateOtherServicesWereInArrears.toString(),
    allowedTimeSinceLastPunishment: params.allowedTimeSinceLastPunishment.toString(),
    maximumNetworkBalance: params.maximumNetworkBalance.toString().replaceAll('.', ''),
    numberOfSuspensionsPeriodToEvaluate: params.numberOfSuspensionsPeriodToEvaluate.toString(),
    requiredOwnershipPeriod: params.requiredOwnershipPeriod.toString(),
    type: Number(params.contractTypeId),
  };
  return sanitizedParams;
};